import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion,AnimatePresence } from "framer-motion";

function Displaymarketing() {
const [index, setIndex] = useState(0);
 const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formType, setFormType] = useState(""); // stores which button opened the form
 const [showModal, setShowModal] = useState(false);
   const [animate, setAnimate] = useState(false);
   const [loading, setLoading] = useState(false);
 const slides = [
    { text: "Smarter Display Ads. Stronger Brand Impact" },
    { text: "Turn Every Ad View into a Growth Opportunity" },
    { text: "Boost Visibility. Drive Conversions. Grow Faster" },
  ];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.5, // delay between each div
    },
  },
};

// alternate slide: left for odd, right for even
const itemVariants = (direction = "left") => ({
  hidden: { opacity: 0, x: direction === "left" ? -50 : 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.8, // slow fade + slide
      ease: "easeInOut",
    },
  },
});
   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
        try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
   body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
 closeModal();
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  return (
    
    <div>
      <Header />
       <main>
   <AnimatePresence>
             {showSuccessModal && (
               <motion.div
                 className="modal-overlay show"
                 initial={{ opacity: 0 }}
                 animate={{ opacity: 1 }}
                 exit={{ opacity: 0 }}
                 style={{
                   position: "fixed",
                   top: 0,
                   left: 0,
                   width: "100%",
                   height: "100%",
                   background: "rgba(0,0,0,0.5)",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                   zIndex: 9999,
                 }}
               >
                 <motion.div
                   className="modal show"
                   initial={{ scale: 0.8, opacity: 0 }}
                   animate={{ scale: 1, opacity: 1 }}
                   exit={{ scale: 0.8, opacity: 0 }}
                   transition={{ duration: 0.3 }}
                   style={{
                     background: "#fff",
                     padding: "30px",
                     borderRadius: "10px",
                     width: "400px",
                     textAlign: "center",
                     boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                   }}
                 >
                   <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                     Message Sent!
                   </h2>
                   <p>Thank you for contacting us. We will get back to you shortly.</p>
                   <button className="vc rg lk gh ml il hi gi _l"
                     onClick={() => setShowSuccessModal(false)}
                    
                   >
                     Close
                   </button>
                 </motion.div>
               </motion.div>
             )}
           </AnimatePresence>
             {/* 🔹 Modal */}
                   {showModal && (
                     <div
                       className={`modal-overlay ${animate ? "show" : ""}`}
                       onClick={(e) => {
                         if (e.target.classList.contains("modal-overlay")) {
                           closeModal();
                         }
                       }}
                       style={{
                         position: "fixed",
                         top: 0,
                         left: 0,
                         right: 0,
                         bottom: 0,
                         background: "rgba(0, 0, 0, 0.5)",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                         zIndex: 1000,
                         opacity: animate ? 1 : 0,
                         transition: "opacity 0.3s ease",
                       }}
                     >
                       <motion.div
                         className="modal-box"
                         initial={{ scale: 0.8, opacity: 0 }}
                         animate={{ scale: 1, opacity: 1 }}
                         exit={{ scale: 0.8, opacity: 0 }}
                         transition={{ duration: 0.3 }}
                         style={{
                           position: "relative",
                           background: "#fff",
                           padding: "30px",
                           borderRadius: "10px",
                           textAlign: "center",
                           boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                         }}
                       >
                         {/* Close button */}
                         <button
                           onClick={closeModal}
                           style={{
                             position: "absolute",
                             top: "10px",
                             right: "15px",
                             background: "transparent",
                             border: "none",
                             fontSize: "22px",
                             cursor: "pointer",
                             color: "#333",
                           }}
                         >
                           ×
                         </button>
           
                         <h2 className="fk tj kk wm bb">
                          Contact Now
                         </h2>
                      <form onSubmit={(e) => handleContactSubmit(e)}>
     <div className="tc sf yo ap zf xi1">
       <div className="vd to/2">
         <input
           type="text"
           name="fullname"
           id="fullname"
           placeholder="Full name"
           value={contactForm.fullname}
           onChange={handleContactChange}
           className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
         />
       </div>
   
       <div className="vd to/2">
         <input
           type="text"
           name="company"
           id="company"
            placeholder="Company name"
           value={contactForm.company}
           onChange={handleContactChange}
           className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
         />
       </div>
     </div>
   
     <div className="tc sf yo ap zf xi1">
       <div className="vd to/2">
         <input
           type="text"
           name="website"
           id="website"
             placeholder="Website"
           value={contactForm.website}
           onChange={handleContactChange}
           className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
         />
       </div>
   
       <div className="vd to/2">
         <input
           type="email"
           name="email"
            placeholder="Email address"
           id="email"
           value={contactForm.email}
           onChange={handleContactChange}
           className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
         />
       </div>
     </div>
   
     <div className="tc sf yo ap zf xi1">
       <div className="vd to/2">
        <input
     type="text"
     name="phone"
     id="phone"
       placeholder="Phone number"
     value={contactForm.phone}
     onChange={(e) => {
       // Allow only digits
       const value = e.target.value.replace(/\D/g, "");
       setContactForm((prev) => ({ ...prev, phone: value }));
     }}
     maxLength={10} // optional: limit to 10 digits
     className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
   />
   
       </div>
     </div>
   
     <div className="fb">
       <textarea
         placeholder="Message"
         rows="3"
         name="message"
         id="message"
         value={contactForm.message}
         onChange={handleContactChange}
         className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
       ></textarea>
     </div>
   
     <div className="tc xf">
         <button
     type="submit"
     className="vc rg lk gh ml il hi gi _l"
     disabled={loading}
   >
     {loading ? "Please wait..." : " Send Message"}
   </button>
   
     </div>
   </form>
                       </motion.div>
                     </div>
                   )}
 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/DisplayMarvideo.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>

     <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
       <motion.section
               initial={{ opacity: 0, y: 100 }}
               whileInView={{ opacity: 1, y: 0 }}
               viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
               transition={{
                 duration: 1.8,
                 ease: "easeOut",
                 type: "spring",
                 stiffness: 40,
                 damping: 20,
               }}
             ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
         Display Marketing
        </h2></motion.section>
      
      </div>
      <br/>
      <div className="container">
        <motion.section
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                transition={{
                  duration: 1.8,
                  ease: "easeOut",
                  type: "spring",
                  stiffness: 40,
                  damping: 20,
                }}
              >
        <div className="left">
          <img src="/images/displaymarket.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
           <motion.section
                   initial={{ opacity: 0, y: 100 }}
                   whileInView={{ opacity: 1, y: 0 }}
                   viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                   transition={{
                     duration: 1.8,
                     ease: "easeOut",
                     type: "spring",
                     stiffness: 40,
                     damping: 20,
                   }}
                 >
          <h3 className="fk tj kk wm bb _b mk">Precision targeting. Powerful results</h3>
          <p className="uo">
            We help B2B companies reach and engage their ideal buyers through targeted display marketing. By delivering personalized ads to the right decision-makers across the web, we boost brand awareness, drive high-quality traffic to your offers, and generate qualified leads that feed your sales pipeline. Our approach integrates with your overall marketing strategy—supporting account-based marketing, nurturing prospects through multiple touchpoints, and maximizing ROI with data-driven optimization.
         </p>
           <div className="tc tf yo zf mb">
             <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Display Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
   Lets chat to discover  
</button>
          </div>
         </motion.section>
        </div>
      </div>

    </section>
    
   <section className="i pg">
                {/* Bg Shapes */}
                   <span className="rc h s r vd fd/5 fh rm"></span>
                   <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />
             
                   {/* Section Title */}
                   <div className="animate_top bb ze rj ki xn vq">
                     <motion.section
                             initial={{ opacity: 0, y: 100 }}
                             whileInView={{ opacity: 1, y: 0 }}
                             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                             transition={{
                               duration: 1.8,
                               ease: "easeOut",
                               type: "spring",
                               stiffness: 40,
                               damping: 20,
                             }}
                           ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
                      How it Matters
                     </h2></motion.section>
                    
                   </div>
            
             {/* Team List */}
          <div className="bb ze i va ki xn jb">
                <motion.section
                      variants={containerVariants}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: false, amount: 0.3 }}
                    >
              <div className="wc qf pn xo gg cp">
            
                 <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                   <div className="c i pg z-1">
                     <center>
                      <img src="images/brand-awareness.png" className="imgsizeicon" alt="Icon" /></center>
                   </div>
                   <h4 className="ek yj mk2 gb">Increases Brand Awareness Among Target Buyers</h4>
                   <p className="hdse">B2B purchase decisions take time. Display ads help keep your brand visible while buyers research options.</p>
                </motion.div>
       
       <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                   <div className="c i pg z-1">
                     <center>
                      <img src="images/targetnq.png" className="imgsizeicon" alt="Icon" /></center>
                   </div>
                   <h4 className="ek yj mk2 gb">Enables Precise Audience Targeting</h4>
                   <p className="hdse">You can target specific roles, industries, and companies—making sure your ads reach the right decision-makers.</p>
                </motion.div>

                  <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                   <div className="c i pg z-1">
                     <center>
                      <img src="images/quality.png" className="imgsizeicon" alt="Icon" /></center>
                   </div>
                   <h4 className="ek yj mk2 gb">Drives Qualified Traffic to Your Content or Offers</h4>
                   <p className="hdse">Display ads can promote gated content like whitepapers or webinars that start the lead capture process.</p>
                </motion.div>
</div>  <br/>
 <div className="wc qf pn pn gg cp">
                   <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                   <div className="c i pg z-1">
                     <center>
                      <img src="images/leads.png" className="imgsizeicon" alt="Icon" /></center>
                   </div>
                   <h4 className="ek yj mk2 gb">Supports Retargeting and Lead Nurturing</h4>
                   <p className="hdse">You can re-engage visitors who showed interest but didn’t convert the first time, moving them closer to a sale.</p>
                  </motion.div>
                   <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                   <div className="c i pg z-1">
                     <center>
                      <img src="images/multi-channel.png" className="imgsizeicon" alt="Icon" /></center>
                   </div>
                   <h4 className="ek yj mk2 gb">Complements Multi-Channel Marketing Strategies</h4>
                   <p className="hdse">Display ads work alongside email, content syndication, and social media to create consistent touchpoints.</p>
                  </motion.div>
                 
               </div>  
               </motion.section>
           <br/>
             </div>
           </section>

           
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Displaymarketing;
